<script>
    import moment from 'moment/src/moment';
    import {mapGetters, mapMutations, mapState} from 'vuex';
    import {getUtmFromCookie} from '@/utils/helpers';

    export default {
        
        data() {
            return {};
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_job: state => state.job.job,
                $_jobApplication: state => state.jobApplication,
                $_eventTracking: state => state.eventTracking,
            }),

            ...mapGetters('jobApplication', {
                $_isApplyAsNewUser: 'isApplyAsNewUser',
                $_isApplyAsGuestUser: 'isApplyAsGuestUser',
            }),
        },

        methods: {

            ...mapMutations('job', {
                $_UPDATE_JOB: 'UPDATE_JOB',
            }),

            ...mapMutations('jobApplication', {
                $_APPLY: 'APPLY',
                $_STORE_APPLY_UUID: 'STORE_APPLY_UUID',
                $_CLOSE_APPLY_FORM: 'CLOSE_APPLY_FORM',
            }),

            async afterApply(application) {
                this.$_STORE_APPLY_UUID(application.uuid);
                this.$_UPDATE_JOB({ key: 'has_applied', value: true });
                this.$_UPDATE_JOB({ key: 'applied_at', value: moment().format('YYYY-MM-DD HH:mm:ss') });
                this.$_APPLY();

                this.afterCompleteApply();
            },

            afterCompleteApply() {
                window.scrollTo(0, 0);
                this.$_CLOSE_APPLY_FORM();
            },

            getUtmParameters() {
                let utm = this.$_eventTracking?.utm;
                if (!utm?.source) {
                    utm = getUtmFromCookie();
                }

                if (!utm?.source) {
                    return null;
                }

                return {
                    source: utm.source,
                    medium: utm.medium,
                    campaign: utm.campaign,
                };
            },

            isResumeAttachmentOptional() {
                const resumeAttachmentOptional = window?.afConfig?.job_apply_resume_optional?.toLowerCase() === 'yes';
                return resumeAttachmentOptional;
            },
        },
    };
</script>
